/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  ErrorLimited,
  Forbidden,
  GatewayTimeout,
  GetUniverseAncestries200Ok,
  GetUniverseAsteroidBeltsAsteroidBeltIdNotFound,
  GetUniverseAsteroidBeltsAsteroidBeltIdOk,
  GetUniverseBloodlines200Ok,
  GetUniverseCategoriesCategoryIdNotFound,
  GetUniverseCategoriesCategoryIdOk,
  GetUniverseConstellationsConstellationIdNotFound,
  GetUniverseConstellationsConstellationIdOk,
  GetUniverseFactions200Ok,
  GetUniverseGraphicsGraphicIdNotFound,
  GetUniverseGraphicsGraphicIdOk,
  GetUniverseGroupsGroupIdNotFound,
  GetUniverseGroupsGroupIdOk,
  GetUniverseMoonsMoonIdNotFound,
  GetUniverseMoonsMoonIdOk,
  GetUniversePlanetsPlanetIdNotFound,
  GetUniversePlanetsPlanetIdOk,
  GetUniverseRaces200Ok,
  GetUniverseRegionsRegionIdNotFound,
  GetUniverseRegionsRegionIdOk,
  GetUniverseStargatesStargateIdNotFound,
  GetUniverseStargatesStargateIdOk,
  GetUniverseStarsStarIdOk,
  GetUniverseStationsStationIdNotFound,
  GetUniverseStationsStationIdOk,
  GetUniverseStructuresStructureIdNotFound,
  GetUniverseStructuresStructureIdOk,
  GetUniverseSystemJumps200Ok,
  GetUniverseSystemKills200Ok,
  GetUniverseSystemsSystemIdNotFound,
  GetUniverseSystemsSystemIdOk,
  GetUniverseTypesTypeIdNotFound,
  GetUniverseTypesTypeIdOk,
  InternalServerError,
  PostUniverseIdsOk,
  PostUniverseNames200Ok,
  PostUniverseNamesNotFound,
  ServiceUnavailable,
  Unauthorized,
} from '../models/index';
import {
    BadRequestFromJSON,
    BadRequestToJSON,
    ErrorLimitedFromJSON,
    ErrorLimitedToJSON,
    ForbiddenFromJSON,
    ForbiddenToJSON,
    GatewayTimeoutFromJSON,
    GatewayTimeoutToJSON,
    GetUniverseAncestries200OkFromJSON,
    GetUniverseAncestries200OkToJSON,
    GetUniverseAsteroidBeltsAsteroidBeltIdNotFoundFromJSON,
    GetUniverseAsteroidBeltsAsteroidBeltIdNotFoundToJSON,
    GetUniverseAsteroidBeltsAsteroidBeltIdOkFromJSON,
    GetUniverseAsteroidBeltsAsteroidBeltIdOkToJSON,
    GetUniverseBloodlines200OkFromJSON,
    GetUniverseBloodlines200OkToJSON,
    GetUniverseCategoriesCategoryIdNotFoundFromJSON,
    GetUniverseCategoriesCategoryIdNotFoundToJSON,
    GetUniverseCategoriesCategoryIdOkFromJSON,
    GetUniverseCategoriesCategoryIdOkToJSON,
    GetUniverseConstellationsConstellationIdNotFoundFromJSON,
    GetUniverseConstellationsConstellationIdNotFoundToJSON,
    GetUniverseConstellationsConstellationIdOkFromJSON,
    GetUniverseConstellationsConstellationIdOkToJSON,
    GetUniverseFactions200OkFromJSON,
    GetUniverseFactions200OkToJSON,
    GetUniverseGraphicsGraphicIdNotFoundFromJSON,
    GetUniverseGraphicsGraphicIdNotFoundToJSON,
    GetUniverseGraphicsGraphicIdOkFromJSON,
    GetUniverseGraphicsGraphicIdOkToJSON,
    GetUniverseGroupsGroupIdNotFoundFromJSON,
    GetUniverseGroupsGroupIdNotFoundToJSON,
    GetUniverseGroupsGroupIdOkFromJSON,
    GetUniverseGroupsGroupIdOkToJSON,
    GetUniverseMoonsMoonIdNotFoundFromJSON,
    GetUniverseMoonsMoonIdNotFoundToJSON,
    GetUniverseMoonsMoonIdOkFromJSON,
    GetUniverseMoonsMoonIdOkToJSON,
    GetUniversePlanetsPlanetIdNotFoundFromJSON,
    GetUniversePlanetsPlanetIdNotFoundToJSON,
    GetUniversePlanetsPlanetIdOkFromJSON,
    GetUniversePlanetsPlanetIdOkToJSON,
    GetUniverseRaces200OkFromJSON,
    GetUniverseRaces200OkToJSON,
    GetUniverseRegionsRegionIdNotFoundFromJSON,
    GetUniverseRegionsRegionIdNotFoundToJSON,
    GetUniverseRegionsRegionIdOkFromJSON,
    GetUniverseRegionsRegionIdOkToJSON,
    GetUniverseStargatesStargateIdNotFoundFromJSON,
    GetUniverseStargatesStargateIdNotFoundToJSON,
    GetUniverseStargatesStargateIdOkFromJSON,
    GetUniverseStargatesStargateIdOkToJSON,
    GetUniverseStarsStarIdOkFromJSON,
    GetUniverseStarsStarIdOkToJSON,
    GetUniverseStationsStationIdNotFoundFromJSON,
    GetUniverseStationsStationIdNotFoundToJSON,
    GetUniverseStationsStationIdOkFromJSON,
    GetUniverseStationsStationIdOkToJSON,
    GetUniverseStructuresStructureIdNotFoundFromJSON,
    GetUniverseStructuresStructureIdNotFoundToJSON,
    GetUniverseStructuresStructureIdOkFromJSON,
    GetUniverseStructuresStructureIdOkToJSON,
    GetUniverseSystemJumps200OkFromJSON,
    GetUniverseSystemJumps200OkToJSON,
    GetUniverseSystemKills200OkFromJSON,
    GetUniverseSystemKills200OkToJSON,
    GetUniverseSystemsSystemIdNotFoundFromJSON,
    GetUniverseSystemsSystemIdNotFoundToJSON,
    GetUniverseSystemsSystemIdOkFromJSON,
    GetUniverseSystemsSystemIdOkToJSON,
    GetUniverseTypesTypeIdNotFoundFromJSON,
    GetUniverseTypesTypeIdNotFoundToJSON,
    GetUniverseTypesTypeIdOkFromJSON,
    GetUniverseTypesTypeIdOkToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    PostUniverseIdsOkFromJSON,
    PostUniverseIdsOkToJSON,
    PostUniverseNames200OkFromJSON,
    PostUniverseNames200OkToJSON,
    PostUniverseNamesNotFoundFromJSON,
    PostUniverseNamesNotFoundToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
    UnauthorizedFromJSON,
    UnauthorizedToJSON,
} from '../models/index';

export interface GetUniverseAncestriesRequest {
    acceptLanguage?: GetUniverseAncestriesAcceptLanguageEnum;
    datasource?: GetUniverseAncestriesDatasourceEnum;
    ifNoneMatch?: string;
    language?: GetUniverseAncestriesLanguageEnum;
}

export interface GetUniverseAsteroidBeltsAsteroidBeltIdRequest {
    asteroidBeltId: number;
    datasource?: GetUniverseAsteroidBeltsAsteroidBeltIdDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetUniverseBloodlinesRequest {
    acceptLanguage?: GetUniverseBloodlinesAcceptLanguageEnum;
    datasource?: GetUniverseBloodlinesDatasourceEnum;
    ifNoneMatch?: string;
    language?: GetUniverseBloodlinesLanguageEnum;
}

export interface GetUniverseCategoriesRequest {
    datasource?: GetUniverseCategoriesDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetUniverseCategoriesCategoryIdRequest {
    categoryId: number;
    acceptLanguage?: GetUniverseCategoriesCategoryIdAcceptLanguageEnum;
    datasource?: GetUniverseCategoriesCategoryIdDatasourceEnum;
    ifNoneMatch?: string;
    language?: GetUniverseCategoriesCategoryIdLanguageEnum;
}

export interface GetUniverseConstellationsRequest {
    datasource?: GetUniverseConstellationsDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetUniverseConstellationsConstellationIdRequest {
    constellationId: number;
    acceptLanguage?: GetUniverseConstellationsConstellationIdAcceptLanguageEnum;
    datasource?: GetUniverseConstellationsConstellationIdDatasourceEnum;
    ifNoneMatch?: string;
    language?: GetUniverseConstellationsConstellationIdLanguageEnum;
}

export interface GetUniverseFactionsRequest {
    acceptLanguage?: GetUniverseFactionsAcceptLanguageEnum;
    datasource?: GetUniverseFactionsDatasourceEnum;
    ifNoneMatch?: string;
    language?: GetUniverseFactionsLanguageEnum;
}

export interface GetUniverseGraphicsRequest {
    datasource?: GetUniverseGraphicsDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetUniverseGraphicsGraphicIdRequest {
    graphicId: number;
    datasource?: GetUniverseGraphicsGraphicIdDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetUniverseGroupsRequest {
    datasource?: GetUniverseGroupsDatasourceEnum;
    ifNoneMatch?: string;
    page?: number;
}

export interface GetUniverseGroupsGroupIdRequest {
    groupId: number;
    acceptLanguage?: GetUniverseGroupsGroupIdAcceptLanguageEnum;
    datasource?: GetUniverseGroupsGroupIdDatasourceEnum;
    ifNoneMatch?: string;
    language?: GetUniverseGroupsGroupIdLanguageEnum;
}

export interface GetUniverseMoonsMoonIdRequest {
    moonId: number;
    datasource?: GetUniverseMoonsMoonIdDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetUniversePlanetsPlanetIdRequest {
    planetId: number;
    datasource?: GetUniversePlanetsPlanetIdDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetUniverseRacesRequest {
    acceptLanguage?: GetUniverseRacesAcceptLanguageEnum;
    datasource?: GetUniverseRacesDatasourceEnum;
    ifNoneMatch?: string;
    language?: GetUniverseRacesLanguageEnum;
}

export interface GetUniverseRegionsRequest {
    datasource?: GetUniverseRegionsDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetUniverseRegionsRegionIdRequest {
    regionId: number;
    acceptLanguage?: GetUniverseRegionsRegionIdAcceptLanguageEnum;
    datasource?: GetUniverseRegionsRegionIdDatasourceEnum;
    ifNoneMatch?: string;
    language?: GetUniverseRegionsRegionIdLanguageEnum;
}

export interface GetUniverseStargatesStargateIdRequest {
    stargateId: number;
    datasource?: GetUniverseStargatesStargateIdDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetUniverseStarsStarIdRequest {
    starId: number;
    datasource?: GetUniverseStarsStarIdDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetUniverseStationsStationIdRequest {
    stationId: number;
    datasource?: GetUniverseStationsStationIdDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetUniverseStructuresRequest {
    datasource?: GetUniverseStructuresDatasourceEnum;
    filter?: GetUniverseStructuresFilterEnum;
    ifNoneMatch?: string;
}

export interface GetUniverseStructuresStructureIdRequest {
    structureId: number;
    datasource?: GetUniverseStructuresStructureIdDatasourceEnum;
    ifNoneMatch?: string;
    token?: string;
}

export interface GetUniverseSystemJumpsRequest {
    datasource?: GetUniverseSystemJumpsDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetUniverseSystemKillsRequest {
    datasource?: GetUniverseSystemKillsDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetUniverseSystemsRequest {
    datasource?: GetUniverseSystemsDatasourceEnum;
    ifNoneMatch?: string;
}

export interface GetUniverseSystemsSystemIdRequest {
    systemId: number;
    acceptLanguage?: GetUniverseSystemsSystemIdAcceptLanguageEnum;
    datasource?: GetUniverseSystemsSystemIdDatasourceEnum;
    ifNoneMatch?: string;
    language?: GetUniverseSystemsSystemIdLanguageEnum;
}

export interface GetUniverseTypesRequest {
    datasource?: GetUniverseTypesDatasourceEnum;
    ifNoneMatch?: string;
    page?: number;
}

export interface GetUniverseTypesTypeIdRequest {
    typeId: number;
    acceptLanguage?: GetUniverseTypesTypeIdAcceptLanguageEnum;
    datasource?: GetUniverseTypesTypeIdDatasourceEnum;
    ifNoneMatch?: string;
    language?: GetUniverseTypesTypeIdLanguageEnum;
}

export interface PostUniverseIdsRequest {
    names: Set<string>;
    acceptLanguage?: PostUniverseIdsAcceptLanguageEnum;
    datasource?: PostUniverseIdsDatasourceEnum;
    language?: PostUniverseIdsLanguageEnum;
}

export interface PostUniverseNamesRequest {
    ids: Set<number>;
    datasource?: PostUniverseNamesDatasourceEnum;
}

/**
 * 
 */
export class UniverseApi extends runtime.BaseAPI {

    /**
     * Get all character ancestries  ---  This route expires daily at 11:05
     * Get ancestries
     */
    async getUniverseAncestriesRaw(requestParameters: GetUniverseAncestriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetUniverseAncestries200Ok>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/ancestries/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetUniverseAncestries200OkFromJSON));
    }

    /**
     * Get all character ancestries  ---  This route expires daily at 11:05
     * Get ancestries
     */
    async getUniverseAncestries(requestParameters: GetUniverseAncestriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetUniverseAncestries200Ok>> {
        const response = await this.getUniverseAncestriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information on an asteroid belt  ---  This route expires daily at 11:05
     * Get asteroid belt information
     */
    async getUniverseAsteroidBeltsAsteroidBeltIdRaw(requestParameters: GetUniverseAsteroidBeltsAsteroidBeltIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUniverseAsteroidBeltsAsteroidBeltIdOk>> {
        if (requestParameters['asteroidBeltId'] == null) {
            throw new runtime.RequiredError(
                'asteroidBeltId',
                'Required parameter "asteroidBeltId" was null or undefined when calling getUniverseAsteroidBeltsAsteroidBeltId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/asteroid_belts/{asteroid_belt_id}/`.replace(`{${"asteroid_belt_id"}}`, encodeURIComponent(String(requestParameters['asteroidBeltId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUniverseAsteroidBeltsAsteroidBeltIdOkFromJSON(jsonValue));
    }

    /**
     * Get information on an asteroid belt  ---  This route expires daily at 11:05
     * Get asteroid belt information
     */
    async getUniverseAsteroidBeltsAsteroidBeltId(requestParameters: GetUniverseAsteroidBeltsAsteroidBeltIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUniverseAsteroidBeltsAsteroidBeltIdOk> {
        const response = await this.getUniverseAsteroidBeltsAsteroidBeltIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of bloodlines  ---  This route expires daily at 11:05
     * Get bloodlines
     */
    async getUniverseBloodlinesRaw(requestParameters: GetUniverseBloodlinesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetUniverseBloodlines200Ok>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/bloodlines/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetUniverseBloodlines200OkFromJSON));
    }

    /**
     * Get a list of bloodlines  ---  This route expires daily at 11:05
     * Get bloodlines
     */
    async getUniverseBloodlines(requestParameters: GetUniverseBloodlinesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetUniverseBloodlines200Ok>> {
        const response = await this.getUniverseBloodlinesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of item categories  ---  This route expires daily at 11:05
     * Get item categories
     */
    async getUniverseCategoriesRaw(requestParameters: GetUniverseCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/categories/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get a list of item categories  ---  This route expires daily at 11:05
     * Get item categories
     */
    async getUniverseCategories(requestParameters: GetUniverseCategoriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getUniverseCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information of an item category  ---  This route expires daily at 11:05
     * Get item category information
     */
    async getUniverseCategoriesCategoryIdRaw(requestParameters: GetUniverseCategoriesCategoryIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUniverseCategoriesCategoryIdOk>> {
        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling getUniverseCategoriesCategoryId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/categories/{category_id}/`.replace(`{${"category_id"}}`, encodeURIComponent(String(requestParameters['categoryId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUniverseCategoriesCategoryIdOkFromJSON(jsonValue));
    }

    /**
     * Get information of an item category  ---  This route expires daily at 11:05
     * Get item category information
     */
    async getUniverseCategoriesCategoryId(requestParameters: GetUniverseCategoriesCategoryIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUniverseCategoriesCategoryIdOk> {
        const response = await this.getUniverseCategoriesCategoryIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of constellations  ---  This route expires daily at 11:05
     * Get constellations
     */
    async getUniverseConstellationsRaw(requestParameters: GetUniverseConstellationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/constellations/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get a list of constellations  ---  This route expires daily at 11:05
     * Get constellations
     */
    async getUniverseConstellations(requestParameters: GetUniverseConstellationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getUniverseConstellationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information on a constellation  ---  This route expires daily at 11:05
     * Get constellation information
     */
    async getUniverseConstellationsConstellationIdRaw(requestParameters: GetUniverseConstellationsConstellationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUniverseConstellationsConstellationIdOk>> {
        if (requestParameters['constellationId'] == null) {
            throw new runtime.RequiredError(
                'constellationId',
                'Required parameter "constellationId" was null or undefined when calling getUniverseConstellationsConstellationId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/constellations/{constellation_id}/`.replace(`{${"constellation_id"}}`, encodeURIComponent(String(requestParameters['constellationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUniverseConstellationsConstellationIdOkFromJSON(jsonValue));
    }

    /**
     * Get information on a constellation  ---  This route expires daily at 11:05
     * Get constellation information
     */
    async getUniverseConstellationsConstellationId(requestParameters: GetUniverseConstellationsConstellationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUniverseConstellationsConstellationIdOk> {
        const response = await this.getUniverseConstellationsConstellationIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of factions  ---  This route expires daily at 11:05
     * Get factions
     */
    async getUniverseFactionsRaw(requestParameters: GetUniverseFactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetUniverseFactions200Ok>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v2/universe/factions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetUniverseFactions200OkFromJSON));
    }

    /**
     * Get a list of factions  ---  This route expires daily at 11:05
     * Get factions
     */
    async getUniverseFactions(requestParameters: GetUniverseFactionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetUniverseFactions200Ok>> {
        const response = await this.getUniverseFactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of graphics  ---  This route expires daily at 11:05
     * Get graphics
     */
    async getUniverseGraphicsRaw(requestParameters: GetUniverseGraphicsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/graphics/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get a list of graphics  ---  This route expires daily at 11:05
     * Get graphics
     */
    async getUniverseGraphics(requestParameters: GetUniverseGraphicsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getUniverseGraphicsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information on a graphic  ---  This route expires daily at 11:05
     * Get graphic information
     */
    async getUniverseGraphicsGraphicIdRaw(requestParameters: GetUniverseGraphicsGraphicIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUniverseGraphicsGraphicIdOk>> {
        if (requestParameters['graphicId'] == null) {
            throw new runtime.RequiredError(
                'graphicId',
                'Required parameter "graphicId" was null or undefined when calling getUniverseGraphicsGraphicId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/graphics/{graphic_id}/`.replace(`{${"graphic_id"}}`, encodeURIComponent(String(requestParameters['graphicId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUniverseGraphicsGraphicIdOkFromJSON(jsonValue));
    }

    /**
     * Get information on a graphic  ---  This route expires daily at 11:05
     * Get graphic information
     */
    async getUniverseGraphicsGraphicId(requestParameters: GetUniverseGraphicsGraphicIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUniverseGraphicsGraphicIdOk> {
        const response = await this.getUniverseGraphicsGraphicIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of item groups  ---  This route expires daily at 11:05
     * Get item groups
     */
    async getUniverseGroupsRaw(requestParameters: GetUniverseGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/groups/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get a list of item groups  ---  This route expires daily at 11:05
     * Get item groups
     */
    async getUniverseGroups(requestParameters: GetUniverseGroupsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getUniverseGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information on an item group  ---  This route expires daily at 11:05
     * Get item group information
     */
    async getUniverseGroupsGroupIdRaw(requestParameters: GetUniverseGroupsGroupIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUniverseGroupsGroupIdOk>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getUniverseGroupsGroupId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/groups/{group_id}/`.replace(`{${"group_id"}}`, encodeURIComponent(String(requestParameters['groupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUniverseGroupsGroupIdOkFromJSON(jsonValue));
    }

    /**
     * Get information on an item group  ---  This route expires daily at 11:05
     * Get item group information
     */
    async getUniverseGroupsGroupId(requestParameters: GetUniverseGroupsGroupIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUniverseGroupsGroupIdOk> {
        const response = await this.getUniverseGroupsGroupIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information on a moon  ---  This route expires daily at 11:05
     * Get moon information
     */
    async getUniverseMoonsMoonIdRaw(requestParameters: GetUniverseMoonsMoonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUniverseMoonsMoonIdOk>> {
        if (requestParameters['moonId'] == null) {
            throw new runtime.RequiredError(
                'moonId',
                'Required parameter "moonId" was null or undefined when calling getUniverseMoonsMoonId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/moons/{moon_id}/`.replace(`{${"moon_id"}}`, encodeURIComponent(String(requestParameters['moonId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUniverseMoonsMoonIdOkFromJSON(jsonValue));
    }

    /**
     * Get information on a moon  ---  This route expires daily at 11:05
     * Get moon information
     */
    async getUniverseMoonsMoonId(requestParameters: GetUniverseMoonsMoonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUniverseMoonsMoonIdOk> {
        const response = await this.getUniverseMoonsMoonIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information on a planet  ---  This route expires daily at 11:05
     * Get planet information
     */
    async getUniversePlanetsPlanetIdRaw(requestParameters: GetUniversePlanetsPlanetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUniversePlanetsPlanetIdOk>> {
        if (requestParameters['planetId'] == null) {
            throw new runtime.RequiredError(
                'planetId',
                'Required parameter "planetId" was null or undefined when calling getUniversePlanetsPlanetId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/planets/{planet_id}/`.replace(`{${"planet_id"}}`, encodeURIComponent(String(requestParameters['planetId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUniversePlanetsPlanetIdOkFromJSON(jsonValue));
    }

    /**
     * Get information on a planet  ---  This route expires daily at 11:05
     * Get planet information
     */
    async getUniversePlanetsPlanetId(requestParameters: GetUniversePlanetsPlanetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUniversePlanetsPlanetIdOk> {
        const response = await this.getUniversePlanetsPlanetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of character races  ---  This route expires daily at 11:05
     * Get character races
     */
    async getUniverseRacesRaw(requestParameters: GetUniverseRacesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetUniverseRaces200Ok>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/races/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetUniverseRaces200OkFromJSON));
    }

    /**
     * Get a list of character races  ---  This route expires daily at 11:05
     * Get character races
     */
    async getUniverseRaces(requestParameters: GetUniverseRacesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetUniverseRaces200Ok>> {
        const response = await this.getUniverseRacesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of regions  ---  This route expires daily at 11:05
     * Get regions
     */
    async getUniverseRegionsRaw(requestParameters: GetUniverseRegionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/regions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get a list of regions  ---  This route expires daily at 11:05
     * Get regions
     */
    async getUniverseRegions(requestParameters: GetUniverseRegionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getUniverseRegionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information on a region  ---  This route expires daily at 11:05
     * Get region information
     */
    async getUniverseRegionsRegionIdRaw(requestParameters: GetUniverseRegionsRegionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUniverseRegionsRegionIdOk>> {
        if (requestParameters['regionId'] == null) {
            throw new runtime.RequiredError(
                'regionId',
                'Required parameter "regionId" was null or undefined when calling getUniverseRegionsRegionId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/regions/{region_id}/`.replace(`{${"region_id"}}`, encodeURIComponent(String(requestParameters['regionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUniverseRegionsRegionIdOkFromJSON(jsonValue));
    }

    /**
     * Get information on a region  ---  This route expires daily at 11:05
     * Get region information
     */
    async getUniverseRegionsRegionId(requestParameters: GetUniverseRegionsRegionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUniverseRegionsRegionIdOk> {
        const response = await this.getUniverseRegionsRegionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information on a stargate  ---  This route expires daily at 11:05
     * Get stargate information
     */
    async getUniverseStargatesStargateIdRaw(requestParameters: GetUniverseStargatesStargateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUniverseStargatesStargateIdOk>> {
        if (requestParameters['stargateId'] == null) {
            throw new runtime.RequiredError(
                'stargateId',
                'Required parameter "stargateId" was null or undefined when calling getUniverseStargatesStargateId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/stargates/{stargate_id}/`.replace(`{${"stargate_id"}}`, encodeURIComponent(String(requestParameters['stargateId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUniverseStargatesStargateIdOkFromJSON(jsonValue));
    }

    /**
     * Get information on a stargate  ---  This route expires daily at 11:05
     * Get stargate information
     */
    async getUniverseStargatesStargateId(requestParameters: GetUniverseStargatesStargateIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUniverseStargatesStargateIdOk> {
        const response = await this.getUniverseStargatesStargateIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information on a star  ---  This route expires daily at 11:05
     * Get star information
     */
    async getUniverseStarsStarIdRaw(requestParameters: GetUniverseStarsStarIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUniverseStarsStarIdOk>> {
        if (requestParameters['starId'] == null) {
            throw new runtime.RequiredError(
                'starId',
                'Required parameter "starId" was null or undefined when calling getUniverseStarsStarId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/stars/{star_id}/`.replace(`{${"star_id"}}`, encodeURIComponent(String(requestParameters['starId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUniverseStarsStarIdOkFromJSON(jsonValue));
    }

    /**
     * Get information on a star  ---  This route expires daily at 11:05
     * Get star information
     */
    async getUniverseStarsStarId(requestParameters: GetUniverseStarsStarIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUniverseStarsStarIdOk> {
        const response = await this.getUniverseStarsStarIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information on a station  ---  This route expires daily at 11:05
     * Get station information
     */
    async getUniverseStationsStationIdRaw(requestParameters: GetUniverseStationsStationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUniverseStationsStationIdOk>> {
        if (requestParameters['stationId'] == null) {
            throw new runtime.RequiredError(
                'stationId',
                'Required parameter "stationId" was null or undefined when calling getUniverseStationsStationId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v2/universe/stations/{station_id}/`.replace(`{${"station_id"}}`, encodeURIComponent(String(requestParameters['stationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUniverseStationsStationIdOkFromJSON(jsonValue));
    }

    /**
     * Get information on a station  ---  This route expires daily at 11:05
     * Get station information
     */
    async getUniverseStationsStationId(requestParameters: GetUniverseStationsStationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUniverseStationsStationIdOk> {
        const response = await this.getUniverseStationsStationIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all public structures  ---  This route is cached for up to 3600 seconds
     * List all public structures
     */
    async getUniverseStructuresRaw(requestParameters: GetUniverseStructuresRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Set<number>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/structures/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List all public structures  ---  This route is cached for up to 3600 seconds
     * List all public structures
     */
    async getUniverseStructures(requestParameters: GetUniverseStructuresRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Set<number>> {
        const response = await this.getUniverseStructuresRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns information on requested structure if you are on the ACL. Otherwise, returns \"Forbidden\" for all inputs.  ---  This route is cached for up to 3600 seconds
     * Get structure information
     */
    async getUniverseStructuresStructureIdRaw(requestParameters: GetUniverseStructuresStructureIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUniverseStructuresStructureIdOk>> {
        if (requestParameters['structureId'] == null) {
            throw new runtime.RequiredError(
                'structureId',
                'Required parameter "structureId" was null or undefined when calling getUniverseStructuresStructureId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("evesso", ["esi-universe.read_structures.v1"]);
        }

        const response = await this.request({
            path: `/v2/universe/structures/{structure_id}/`.replace(`{${"structure_id"}}`, encodeURIComponent(String(requestParameters['structureId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUniverseStructuresStructureIdOkFromJSON(jsonValue));
    }

    /**
     * Returns information on requested structure if you are on the ACL. Otherwise, returns \"Forbidden\" for all inputs.  ---  This route is cached for up to 3600 seconds
     * Get structure information
     */
    async getUniverseStructuresStructureId(requestParameters: GetUniverseStructuresStructureIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUniverseStructuresStructureIdOk> {
        const response = await this.getUniverseStructuresStructureIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the number of jumps in solar systems within the last hour ending at the timestamp of the Last-Modified header, excluding wormhole space. Only systems with jumps will be listed  ---  This route is cached for up to 3600 seconds
     * Get system jumps
     */
    async getUniverseSystemJumpsRaw(requestParameters: GetUniverseSystemJumpsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetUniverseSystemJumps200Ok>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/system_jumps/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetUniverseSystemJumps200OkFromJSON));
    }

    /**
     * Get the number of jumps in solar systems within the last hour ending at the timestamp of the Last-Modified header, excluding wormhole space. Only systems with jumps will be listed  ---  This route is cached for up to 3600 seconds
     * Get system jumps
     */
    async getUniverseSystemJumps(requestParameters: GetUniverseSystemJumpsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetUniverseSystemJumps200Ok>> {
        const response = await this.getUniverseSystemJumpsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the number of ship, pod and NPC kills per solar system within the last hour ending at the timestamp of the Last-Modified header, excluding wormhole space. Only systems with kills will be listed  ---  This route is cached for up to 3600 seconds
     * Get system kills
     */
    async getUniverseSystemKillsRaw(requestParameters: GetUniverseSystemKillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetUniverseSystemKills200Ok>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v2/universe/system_kills/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetUniverseSystemKills200OkFromJSON));
    }

    /**
     * Get the number of ship, pod and NPC kills per solar system within the last hour ending at the timestamp of the Last-Modified header, excluding wormhole space. Only systems with kills will be listed  ---  This route is cached for up to 3600 seconds
     * Get system kills
     */
    async getUniverseSystemKills(requestParameters: GetUniverseSystemKillsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetUniverseSystemKills200Ok>> {
        const response = await this.getUniverseSystemKillsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of solar systems  ---  This route expires daily at 11:05
     * Get solar systems
     */
    async getUniverseSystemsRaw(requestParameters: GetUniverseSystemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/systems/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get a list of solar systems  ---  This route expires daily at 11:05
     * Get solar systems
     */
    async getUniverseSystems(requestParameters: GetUniverseSystemsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getUniverseSystemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information on a solar system.  ---  This route expires daily at 11:05
     * Get solar system information
     */
    async getUniverseSystemsSystemIdRaw(requestParameters: GetUniverseSystemsSystemIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUniverseSystemsSystemIdOk>> {
        if (requestParameters['systemId'] == null) {
            throw new runtime.RequiredError(
                'systemId',
                'Required parameter "systemId" was null or undefined when calling getUniverseSystemsSystemId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v4/universe/systems/{system_id}/`.replace(`{${"system_id"}}`, encodeURIComponent(String(requestParameters['systemId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUniverseSystemsSystemIdOkFromJSON(jsonValue));
    }

    /**
     * Get information on a solar system.  ---  This route expires daily at 11:05
     * Get solar system information
     */
    async getUniverseSystemsSystemId(requestParameters: GetUniverseSystemsSystemIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUniverseSystemsSystemIdOk> {
        const response = await this.getUniverseSystemsSystemIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of type ids  ---  This route expires daily at 11:05
     * Get types
     */
    async getUniverseTypesRaw(requestParameters: GetUniverseTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/universe/types/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get a list of type ids  ---  This route expires daily at 11:05
     * Get types
     */
    async getUniverseTypes(requestParameters: GetUniverseTypesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getUniverseTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get information on a type  ---  This route expires daily at 11:05
     * Get type information
     */
    async getUniverseTypesTypeIdRaw(requestParameters: GetUniverseTypesTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUniverseTypesTypeIdOk>> {
        if (requestParameters['typeId'] == null) {
            throw new runtime.RequiredError(
                'typeId',
                'Required parameter "typeId" was null or undefined when calling getUniverseTypesTypeId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v3/universe/types/{type_id}/`.replace(`{${"type_id"}}`, encodeURIComponent(String(requestParameters['typeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUniverseTypesTypeIdOkFromJSON(jsonValue));
    }

    /**
     * Get information on a type  ---  This route expires daily at 11:05
     * Get type information
     */
    async getUniverseTypesTypeId(requestParameters: GetUniverseTypesTypeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUniverseTypesTypeIdOk> {
        const response = await this.getUniverseTypesTypeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve a set of names to IDs in the following categories: agents, alliances, characters, constellations, corporations factions, inventory_types, regions, stations, and systems. Only exact matches will be returned. All names searched for are cached for 12 hours  --- 
     * Bulk names to IDs
     */
    async postUniverseIdsRaw(requestParameters: PostUniverseIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostUniverseIdsOk>> {
        if (requestParameters['names'] == null) {
            throw new runtime.RequiredError(
                'names',
                'Required parameter "names" was null or undefined when calling postUniverseIds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        const response = await this.request({
            path: `/v1/universe/ids/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['names'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostUniverseIdsOkFromJSON(jsonValue));
    }

    /**
     * Resolve a set of names to IDs in the following categories: agents, alliances, characters, constellations, corporations factions, inventory_types, regions, stations, and systems. Only exact matches will be returned. All names searched for are cached for 12 hours  --- 
     * Bulk names to IDs
     */
    async postUniverseIds(requestParameters: PostUniverseIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostUniverseIdsOk> {
        const response = await this.postUniverseIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve a set of IDs to names and categories. Supported ID\'s for resolving are: Characters, Corporations, Alliances, Stations, Solar Systems, Constellations, Regions, Types, Factions  --- 
     * Get names and categories for a set of IDs
     */
    async postUniverseNamesRaw(requestParameters: PostUniverseNamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PostUniverseNames200Ok>>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling postUniverseNames().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v3/universe/names/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ids'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostUniverseNames200OkFromJSON));
    }

    /**
     * Resolve a set of IDs to names and categories. Supported ID\'s for resolving are: Characters, Corporations, Alliances, Stations, Solar Systems, Constellations, Regions, Types, Factions  --- 
     * Get names and categories for a set of IDs
     */
    async postUniverseNames(requestParameters: PostUniverseNamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PostUniverseNames200Ok>> {
        const response = await this.postUniverseNamesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetUniverseAncestriesAcceptLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseAncestriesAcceptLanguageEnum = typeof GetUniverseAncestriesAcceptLanguageEnum[keyof typeof GetUniverseAncestriesAcceptLanguageEnum];
/**
 * @export
 */
export const GetUniverseAncestriesDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseAncestriesDatasourceEnum = typeof GetUniverseAncestriesDatasourceEnum[keyof typeof GetUniverseAncestriesDatasourceEnum];
/**
 * @export
 */
export const GetUniverseAncestriesLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseAncestriesLanguageEnum = typeof GetUniverseAncestriesLanguageEnum[keyof typeof GetUniverseAncestriesLanguageEnum];
/**
 * @export
 */
export const GetUniverseAsteroidBeltsAsteroidBeltIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseAsteroidBeltsAsteroidBeltIdDatasourceEnum = typeof GetUniverseAsteroidBeltsAsteroidBeltIdDatasourceEnum[keyof typeof GetUniverseAsteroidBeltsAsteroidBeltIdDatasourceEnum];
/**
 * @export
 */
export const GetUniverseBloodlinesAcceptLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseBloodlinesAcceptLanguageEnum = typeof GetUniverseBloodlinesAcceptLanguageEnum[keyof typeof GetUniverseBloodlinesAcceptLanguageEnum];
/**
 * @export
 */
export const GetUniverseBloodlinesDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseBloodlinesDatasourceEnum = typeof GetUniverseBloodlinesDatasourceEnum[keyof typeof GetUniverseBloodlinesDatasourceEnum];
/**
 * @export
 */
export const GetUniverseBloodlinesLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseBloodlinesLanguageEnum = typeof GetUniverseBloodlinesLanguageEnum[keyof typeof GetUniverseBloodlinesLanguageEnum];
/**
 * @export
 */
export const GetUniverseCategoriesDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseCategoriesDatasourceEnum = typeof GetUniverseCategoriesDatasourceEnum[keyof typeof GetUniverseCategoriesDatasourceEnum];
/**
 * @export
 */
export const GetUniverseCategoriesCategoryIdAcceptLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseCategoriesCategoryIdAcceptLanguageEnum = typeof GetUniverseCategoriesCategoryIdAcceptLanguageEnum[keyof typeof GetUniverseCategoriesCategoryIdAcceptLanguageEnum];
/**
 * @export
 */
export const GetUniverseCategoriesCategoryIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseCategoriesCategoryIdDatasourceEnum = typeof GetUniverseCategoriesCategoryIdDatasourceEnum[keyof typeof GetUniverseCategoriesCategoryIdDatasourceEnum];
/**
 * @export
 */
export const GetUniverseCategoriesCategoryIdLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseCategoriesCategoryIdLanguageEnum = typeof GetUniverseCategoriesCategoryIdLanguageEnum[keyof typeof GetUniverseCategoriesCategoryIdLanguageEnum];
/**
 * @export
 */
export const GetUniverseConstellationsDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseConstellationsDatasourceEnum = typeof GetUniverseConstellationsDatasourceEnum[keyof typeof GetUniverseConstellationsDatasourceEnum];
/**
 * @export
 */
export const GetUniverseConstellationsConstellationIdAcceptLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseConstellationsConstellationIdAcceptLanguageEnum = typeof GetUniverseConstellationsConstellationIdAcceptLanguageEnum[keyof typeof GetUniverseConstellationsConstellationIdAcceptLanguageEnum];
/**
 * @export
 */
export const GetUniverseConstellationsConstellationIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseConstellationsConstellationIdDatasourceEnum = typeof GetUniverseConstellationsConstellationIdDatasourceEnum[keyof typeof GetUniverseConstellationsConstellationIdDatasourceEnum];
/**
 * @export
 */
export const GetUniverseConstellationsConstellationIdLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseConstellationsConstellationIdLanguageEnum = typeof GetUniverseConstellationsConstellationIdLanguageEnum[keyof typeof GetUniverseConstellationsConstellationIdLanguageEnum];
/**
 * @export
 */
export const GetUniverseFactionsAcceptLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseFactionsAcceptLanguageEnum = typeof GetUniverseFactionsAcceptLanguageEnum[keyof typeof GetUniverseFactionsAcceptLanguageEnum];
/**
 * @export
 */
export const GetUniverseFactionsDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseFactionsDatasourceEnum = typeof GetUniverseFactionsDatasourceEnum[keyof typeof GetUniverseFactionsDatasourceEnum];
/**
 * @export
 */
export const GetUniverseFactionsLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseFactionsLanguageEnum = typeof GetUniverseFactionsLanguageEnum[keyof typeof GetUniverseFactionsLanguageEnum];
/**
 * @export
 */
export const GetUniverseGraphicsDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseGraphicsDatasourceEnum = typeof GetUniverseGraphicsDatasourceEnum[keyof typeof GetUniverseGraphicsDatasourceEnum];
/**
 * @export
 */
export const GetUniverseGraphicsGraphicIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseGraphicsGraphicIdDatasourceEnum = typeof GetUniverseGraphicsGraphicIdDatasourceEnum[keyof typeof GetUniverseGraphicsGraphicIdDatasourceEnum];
/**
 * @export
 */
export const GetUniverseGroupsDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseGroupsDatasourceEnum = typeof GetUniverseGroupsDatasourceEnum[keyof typeof GetUniverseGroupsDatasourceEnum];
/**
 * @export
 */
export const GetUniverseGroupsGroupIdAcceptLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseGroupsGroupIdAcceptLanguageEnum = typeof GetUniverseGroupsGroupIdAcceptLanguageEnum[keyof typeof GetUniverseGroupsGroupIdAcceptLanguageEnum];
/**
 * @export
 */
export const GetUniverseGroupsGroupIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseGroupsGroupIdDatasourceEnum = typeof GetUniverseGroupsGroupIdDatasourceEnum[keyof typeof GetUniverseGroupsGroupIdDatasourceEnum];
/**
 * @export
 */
export const GetUniverseGroupsGroupIdLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseGroupsGroupIdLanguageEnum = typeof GetUniverseGroupsGroupIdLanguageEnum[keyof typeof GetUniverseGroupsGroupIdLanguageEnum];
/**
 * @export
 */
export const GetUniverseMoonsMoonIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseMoonsMoonIdDatasourceEnum = typeof GetUniverseMoonsMoonIdDatasourceEnum[keyof typeof GetUniverseMoonsMoonIdDatasourceEnum];
/**
 * @export
 */
export const GetUniversePlanetsPlanetIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniversePlanetsPlanetIdDatasourceEnum = typeof GetUniversePlanetsPlanetIdDatasourceEnum[keyof typeof GetUniversePlanetsPlanetIdDatasourceEnum];
/**
 * @export
 */
export const GetUniverseRacesAcceptLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseRacesAcceptLanguageEnum = typeof GetUniverseRacesAcceptLanguageEnum[keyof typeof GetUniverseRacesAcceptLanguageEnum];
/**
 * @export
 */
export const GetUniverseRacesDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseRacesDatasourceEnum = typeof GetUniverseRacesDatasourceEnum[keyof typeof GetUniverseRacesDatasourceEnum];
/**
 * @export
 */
export const GetUniverseRacesLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseRacesLanguageEnum = typeof GetUniverseRacesLanguageEnum[keyof typeof GetUniverseRacesLanguageEnum];
/**
 * @export
 */
export const GetUniverseRegionsDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseRegionsDatasourceEnum = typeof GetUniverseRegionsDatasourceEnum[keyof typeof GetUniverseRegionsDatasourceEnum];
/**
 * @export
 */
export const GetUniverseRegionsRegionIdAcceptLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseRegionsRegionIdAcceptLanguageEnum = typeof GetUniverseRegionsRegionIdAcceptLanguageEnum[keyof typeof GetUniverseRegionsRegionIdAcceptLanguageEnum];
/**
 * @export
 */
export const GetUniverseRegionsRegionIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseRegionsRegionIdDatasourceEnum = typeof GetUniverseRegionsRegionIdDatasourceEnum[keyof typeof GetUniverseRegionsRegionIdDatasourceEnum];
/**
 * @export
 */
export const GetUniverseRegionsRegionIdLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseRegionsRegionIdLanguageEnum = typeof GetUniverseRegionsRegionIdLanguageEnum[keyof typeof GetUniverseRegionsRegionIdLanguageEnum];
/**
 * @export
 */
export const GetUniverseStargatesStargateIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseStargatesStargateIdDatasourceEnum = typeof GetUniverseStargatesStargateIdDatasourceEnum[keyof typeof GetUniverseStargatesStargateIdDatasourceEnum];
/**
 * @export
 */
export const GetUniverseStarsStarIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseStarsStarIdDatasourceEnum = typeof GetUniverseStarsStarIdDatasourceEnum[keyof typeof GetUniverseStarsStarIdDatasourceEnum];
/**
 * @export
 */
export const GetUniverseStationsStationIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseStationsStationIdDatasourceEnum = typeof GetUniverseStationsStationIdDatasourceEnum[keyof typeof GetUniverseStationsStationIdDatasourceEnum];
/**
 * @export
 */
export const GetUniverseStructuresDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseStructuresDatasourceEnum = typeof GetUniverseStructuresDatasourceEnum[keyof typeof GetUniverseStructuresDatasourceEnum];
/**
 * @export
 */
export const GetUniverseStructuresFilterEnum = {
    Market: 'market',
    ManufacturingBasic: 'manufacturing_basic'
} as const;
export type GetUniverseStructuresFilterEnum = typeof GetUniverseStructuresFilterEnum[keyof typeof GetUniverseStructuresFilterEnum];
/**
 * @export
 */
export const GetUniverseStructuresStructureIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseStructuresStructureIdDatasourceEnum = typeof GetUniverseStructuresStructureIdDatasourceEnum[keyof typeof GetUniverseStructuresStructureIdDatasourceEnum];
/**
 * @export
 */
export const GetUniverseSystemJumpsDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseSystemJumpsDatasourceEnum = typeof GetUniverseSystemJumpsDatasourceEnum[keyof typeof GetUniverseSystemJumpsDatasourceEnum];
/**
 * @export
 */
export const GetUniverseSystemKillsDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseSystemKillsDatasourceEnum = typeof GetUniverseSystemKillsDatasourceEnum[keyof typeof GetUniverseSystemKillsDatasourceEnum];
/**
 * @export
 */
export const GetUniverseSystemsDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseSystemsDatasourceEnum = typeof GetUniverseSystemsDatasourceEnum[keyof typeof GetUniverseSystemsDatasourceEnum];
/**
 * @export
 */
export const GetUniverseSystemsSystemIdAcceptLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseSystemsSystemIdAcceptLanguageEnum = typeof GetUniverseSystemsSystemIdAcceptLanguageEnum[keyof typeof GetUniverseSystemsSystemIdAcceptLanguageEnum];
/**
 * @export
 */
export const GetUniverseSystemsSystemIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseSystemsSystemIdDatasourceEnum = typeof GetUniverseSystemsSystemIdDatasourceEnum[keyof typeof GetUniverseSystemsSystemIdDatasourceEnum];
/**
 * @export
 */
export const GetUniverseSystemsSystemIdLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseSystemsSystemIdLanguageEnum = typeof GetUniverseSystemsSystemIdLanguageEnum[keyof typeof GetUniverseSystemsSystemIdLanguageEnum];
/**
 * @export
 */
export const GetUniverseTypesDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseTypesDatasourceEnum = typeof GetUniverseTypesDatasourceEnum[keyof typeof GetUniverseTypesDatasourceEnum];
/**
 * @export
 */
export const GetUniverseTypesTypeIdAcceptLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseTypesTypeIdAcceptLanguageEnum = typeof GetUniverseTypesTypeIdAcceptLanguageEnum[keyof typeof GetUniverseTypesTypeIdAcceptLanguageEnum];
/**
 * @export
 */
export const GetUniverseTypesTypeIdDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetUniverseTypesTypeIdDatasourceEnum = typeof GetUniverseTypesTypeIdDatasourceEnum[keyof typeof GetUniverseTypesTypeIdDatasourceEnum];
/**
 * @export
 */
export const GetUniverseTypesTypeIdLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type GetUniverseTypesTypeIdLanguageEnum = typeof GetUniverseTypesTypeIdLanguageEnum[keyof typeof GetUniverseTypesTypeIdLanguageEnum];
/**
 * @export
 */
export const PostUniverseIdsAcceptLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type PostUniverseIdsAcceptLanguageEnum = typeof PostUniverseIdsAcceptLanguageEnum[keyof typeof PostUniverseIdsAcceptLanguageEnum];
/**
 * @export
 */
export const PostUniverseIdsDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type PostUniverseIdsDatasourceEnum = typeof PostUniverseIdsDatasourceEnum[keyof typeof PostUniverseIdsDatasourceEnum];
/**
 * @export
 */
export const PostUniverseIdsLanguageEnum = {
    En: 'en',
    EnUs: 'en-us',
    De: 'de',
    Fr: 'fr',
    Ja: 'ja',
    Ru: 'ru',
    Zh: 'zh',
    Ko: 'ko',
    Es: 'es'
} as const;
export type PostUniverseIdsLanguageEnum = typeof PostUniverseIdsLanguageEnum[keyof typeof PostUniverseIdsLanguageEnum];
/**
 * @export
 */
export const PostUniverseNamesDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type PostUniverseNamesDatasourceEnum = typeof PostUniverseNamesDatasourceEnum[keyof typeof PostUniverseNamesDatasourceEnum];
